import {KeyValueDto} from "../../repositories/dto/key-value.dto";
import {PermissionScope} from "../../services/auth/permission-scope.enum";
import {Feature} from "../../libs/enum/feature.enum";

export class NavItem {

  public readonly id!: string;
  public readonly title!: string;
  public readonly icon!: string;
  public readonly route!: string; // path for the route - on click
  public readonly reloadRoute: boolean = false; // always reload component
  public readonly paths: string[] = []; // paths where the menu is expanded
  public readonly parent?: NavItem;
  public readonly params: KeyValueDto[] = [];
  public children: NavItem[] = [];
  public readonly permissions: PermissionScope[] = []; // everyone must be present (AND)
  public readonly features: Feature[] = []; // everyone must be present (AND)
  public selected = false;
  public selectedChild = false;

  constructor(init?: Partial<NavItem>) {
    Object.assign(this, init);
  }

  public hasChildren(): boolean {
    return (this.children && this.children.length > 0);
  }

  public getChildren(): NavItem[] {
    return this.hasChildren() ? this.children : [];
  }

  public isSelected(): boolean {
    return this.selected;
  }

  public hasSelectedChild(): boolean {
    return this.selectedChild;
  }

  public isSelectedInTree(): boolean {
    return this.isSelected() || this.hasSelectedChild();
  }
}
